import { formatUnits } from 'viem';

import { CancelOrderButton } from '@/components/TradeHistoryTable/cells/CancelOrderButton';

import { isTriggerOrderType } from '@/constants/advancedOrder';

import { fontStyles } from '@/styles/typography';

import { LimitOrderItem } from '@/utils/0x.types';
import { TRADE_TYPE } from '@/utils/0x/history/status';
import { routes } from '@/utils/routes';

import {
  AmountCell,
  type BuyTokenSelection,
  NetworkCell,
  PriceCell,
  RelativeTime,
  ROW_CLASSES,
  TypeCell,
} from './cells';

export const OpenOrderRow = ({
  item,
  buySelection,
}: {
  item: LimitOrderItem;
  buySelection?: BuyTokenSelection;
}) => {
  const sellAmount = item.makerTokenResult
    ? Number(formatUnits(BigInt(item.makerAmount), item.makerTokenResult.decimals))
    : 0;
  const buyAmount = item.takerTokenResult
    ? Number(formatUnits(BigInt(item.takerAmount), item.takerTokenResult.decimals))
    : 0;
  const total = BigInt(item.takerAmount);
  const remaining = BigInt(item.remainingFillableTakerAmount);
  const fillPct = Math.min(
    100,
    Math.max(0, total > 0n ? Number(((total - remaining) * 100n) / total) : 0),
  );
  const sell = {
    address: item.makerToken,
    symbol: item.makerTokenResult?.symbol ?? '',
    amount: sellAmount,
    chainId: item.chainId,
  };
  const buy = {
    address: item.takerToken,
    symbol: item.takerTokenResult?.symbol ?? '',
    amount: buyAmount,
    chainId: item.chainId,
  };

  return (
    <div className={ROW_CLASSES}>
      <NetworkCell originChainId={item.chainId} />
      <AmountCell {...sell} buySelection={buySelection} />
      <AmountCell
        {...buy}
        buySelection={buySelection}
        isApproximate={isTriggerOrderType(item.advancedOrderType)}
      />
      <PriceCell sell={sell} buy={buy} />
      <div className="flex flex-col items-start min-w-0">
        <RelativeTime date={new Date(Number(item.expiry) * 1000)} prefix="Expires" />
        <span
          className={fontStyles({
            variant: 'CAPTION',
            class: 'text-token-gray-700 whitespace-nowrap',
          })}
        >
          {fillPct}% filled
        </span>
      </div>
      <TypeCell
        type={item.advancedOrderType ?? TRADE_TYPE.LIMIT}
        detailsHref={{
          pathname: routes.TRADE_HISTORY,
          query: { tab: ['open-orders'] },
        }}
      />
      <div className="flex items-center justify-end pl-2">
        <CancelOrderButton item={item} />
      </div>
    </div>
  );
};
